import { LitElement, html, css } from 'lit';
import templateJsonStore from './TemplateJsonStore';
import { findByValueOrKeyValue } from './TemplateJsonSlice';
import './TemplateSearchResult.js';

class TemplateSearchSubWindow extends LitElement {
    static get properties() {
        return {
            searchQuery: { type: String },
            searchItems: { type: Array },
            visible: { type: Boolean }
        };
    }

    static get styles() {
        return css`
        :host {
            display: none;
            top: 0;
            left: 0;
            bottom: 100px;
            position: absolute;
            background: white;
            border: 1px solid #0000005e;
            border-radius: 10px;
            padding: 10px;
            right: 0;
            z-index: 1100;
            min-height: 100px;
        }

        :host([visible]) {
            display: flex;
            flex-direction: column;
        }

        .search-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 20px;
        }

        input[type="text"] {
            padding: 10px 40px 10px 15px;
            border: 1px solid #ccc;
            border-radius: 30px;
            font-size: 16px;
            width: 100%;
            outline: none;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
        }

        input:focus {
            border-color: #007BFF;
            box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
        }

        .results {
            margin-top: 20px;
            width: 60%;
        }

        .item {
            padding: 10px;
            margin: 5px 0;
            border-radius: 10px;
            background-color: #f0f0f0;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .clear-icon {
            position: absolute;
            top: 15px;
            right: 17px;
            color: rgb(135, 135, 135);
            cursor: pointer;
        }

        .search-results {
            overflow: auto;
        }
`;
    }

    constructor() {
        super();
        this.searchQuery = '';
        this.searchItems = '';
        this.visible = false;

        window.addEventListener('to-element', this.handleToElement.bind(this));
        window.addEventListener('to-element-and-select', this.handleToElement.bind(this));
    }

    updated(changedProperties) {
        requestAnimationFrame(() => {
            if (changedProperties.has('visible')) {
                this.visible ? this.setAttribute('visible', '') : this.removeAttribute('visible');

                if (this.visible) {
                    this.shadowRoot.querySelector('input').focus();
                }
            }
            if (changedProperties.has('searchQuery')) {
                this.filterItems();
            }
        })
    }

    handleToElement(e) {
        this.hide();
    }

    updateSearchQuery(e) {
        this.searchQuery = e.target.value;
    }

    filterItems() {
        if (!this.searchQuery) {
            this.searchItems = [];
            return;
        }

        const findElements = findByValueOrKeyValue(templateJsonStore.getState(), this.searchQuery);
        this.searchItems = findElements;
    }

    show() {
        this.visible = true;
        this.filterItems();
    }

    hide() {
        this.visible = false;
    }

    handleFilterClear() {
        this.searchQuery = '';
    }

    render() {
        return html`
    <input
        class="filter-box"
        type="text"
        placeholder="検索..."
        .value="${this.searchQuery}"
        @input="${this.updateSearchQuery}"
    >
            <div class="clear-icon" title="検索削除" id="clear-icon" @click=${this.handleFilterClear}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
            </div>
        </input>
        
        <div class="search-results">
            ${this.searchItems.length > 0
                ? html`
                ${this.searchItems.map(
                    (item) => {

                        let topPageName = item.topLevelParent.tagName;
                        if (item.topLevelParent.domId && item.topLevelParent.domId.trim() !== '') {
                            topPageName = item.topLevelParent.domId;
                        }
                        if (item.topLevelParent.explain && item.topLevelParent.explain.trim() !== '') {
                            topPageName = topPageName + '(' + item.topLevelParent.explain + ')';
                        }

                        let targetElementName = item.tagName;
                        if (item.domId && item.domId.trim() !== '') {
                            targetElementName = item.domId;
                        }
                        if (item.explain && item.explain.trim() !== '') {
                            targetElementName = targetElementName + '(' + item.explain + ')';
                        }

                        let listItemMessage = '';
                        if (item.topLevelParent.id === item.id) {
                            listItemMessage = topPageName;
                        } else {
                            listItemMessage = topPageName + ' > ' + targetElementName;
                        }

                        const toElement = {
                            topTemplateId: item.topLevelParent.id,
                            targetTemplateId: item.id,
                            expandNode : true,
                        }

                        return html`<template-search-result .pageTitle="${topPageName}" .componentName="${targetElementName}" .toElement="${JSON.stringify(toElement)}"></template-search-result>`
                    }
                )}
                `
                : html`<p>${this.searchQuery === '' ? '検索ワードを入力してください' : '見つかりませんでした'}</p>`}
        </div>
    `;
    }
}

customElements.define('template-search-sub-window', TemplateSearchSubWindow);